import Vue from 'vue'
import VueGtag from 'vue-gtag'

export default ({ isDev, app, store }, inject) => {
  if (isDev) {
    console.log('Skipping GA in development')
  } else {
    Vue.use(VueGtag, {
      config: { id: 'G-KB6Z3K919E' }
    }, app.router)

    // 先準備用戶屬性資料
    const userProperties = {
      platform: store.state.isApp ? 'app' : 'web'
    }
    if (store.state.isApp) {
      userProperties.device_code = store.state.deviceCode || ''
      userProperties.member_id = store.state.auth.user?.AUid || ''
      if (store.state.userDefaultCommunity) {
        userProperties.community_name = store.state.userDefaultCommunity.Community || ''
        userProperties.community_id = store.state.userDefaultCommunity.Id || ''
      }
    }

    Vue.$gtag.set({ user_properties: userProperties })
  }
  const gaLogEvent = (event, param) => {
    let params = { channel: store.state.isApp ? 'app' : 'web' }
    if (typeof param === 'object' && param !== null) {
      params = { ...params, ...param }
    } else if (typeof param === 'string' || typeof param === 'number') {
      params.value = param
    }
    Vue.$gtag.event(event, params)
  }
  Vue.prototype.$gaLogEvent = isDev ? () => {} : gaLogEvent
  inject('gaLogEvent', isDev ? () => {} : gaLogEvent)
}
